module.exports = __webpack_public_path__ + "img/play-alle.8cb12804.svg";